const numeral = require('numeral');
import { DATA_FORMAT } from '@sitegen/common/constants'; ;

export function formatUnit(value: number | string, format: DATA_FORMAT): number {
    const numValue = parseInt(value as string, 10);
    switch (format) {
    case DATA_FORMAT.NUMBER:
        return numValue;
    case DATA_FORMAT.HOUR:
        return numeral(numValue / (60 * 60)).format('0.[00]');
    case DATA_FORMAT.MINUTE:
        return numeral(numValue / 60).format('0.[00]');
    default:
        return numValue;
    }
}
